import theme1 from "./theme1";
import theme2 from "./theme2";
import theme3 from "./theme3";

export default [theme1, theme2, theme3];
